import { useContext, useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { UseCasesContext } from "../../../../context/useCases"
import { FiledType, Form } from "../../../components/form"
import { Menu } from "../../../components/menu"
import { useTypedSelector } from "../../../../hooks/useTypedSelector"

export const UserAdd = () => {
    const navigate = useNavigate();
    
    let { id } = useParams();

    let useCases = useContext(UseCasesContext)
    const [form, setForm] = useState<{
        name: string,
        login: string,
        pass: string,
        role: string,
    }>({
        name: "",
        login: "",
        pass: "",
        role: "default",
    })

    const submit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        if (form.name !== "" && form.login !== "" && form.pass !== "" && form.role.length !== 0) {
            if (id) {
                useCases?.userUseCase.UpdateUser(id!, form.name!, form.login!, () => { navigate(-1) })
            } else {
                useCases?.userUseCase.CreateUser(form.name!, form.login!, form.pass!, form.role!, () => { navigate(-1) })
            }
        }
    }

    const updateForm = (name: string, value: any) => {
        setForm({
            ...form,
            [name]: value,
        })
    }

    const readUserById = async (id: UniqueId) => {
        let response = await useCases?.userUseCase.ReadUserById(id)
        if (response instanceof Error) {

        } else {
            setForm({
                name: response?.Name()!,
                login: response?.Login()!,
                pass: response?.Pass()!,
                role: response?.Role()!,
            })
        }
    }

    const formatDate = (day: Date) => {
        const yyyy = day.getFullYear();
        let mm = (day.getMonth() + 1).toString(); // Months start at 0!
        let dd = day.getDate().toString();

        if (dd.length == 1) dd = '0' + dd;
        if (mm.length == 1) mm = '0' + mm;

        return dd + '.' + mm + '.' + yyyy;
    }

    useEffect(() => {
        if (id) {
            readUserById(id)
        }
    }, [id])

    const users = useTypedSelector(({ user }) => {
        return user
    })

    const updateFields = [
        {
            name: "name",
            title: "Имя",
            placeholder: "Укажите имя",
            value: form.name,
            type: FiledType.Text,
        },
        {
            name: "login",
            title: "Логин",
            placeholder: "Укажите логин",
            value: form.login,
            type: FiledType.Text,
        },
    ]

    useEffect(() => {
        if (id) {
            readUserById(id)
        }
    }, [id])

    return (
        <div className="layout-page" >
            <Menu />
            <div className="content-wrapper" >
                <div className="container-xxl flex-grow-1 container-p-y">
                    <div className="row mx-1">
                        <div className="col-sm-12 col-md-12">
                            <h4 className="fw-bold py-3 mb-4"><span className="text-muted fw-light">Пользователь /</span> {id ? "Редактировать пользователя" : "Добавить пользователя"}</h4>
                        </div>
                        <div className="card">
                            <div className="card-header d-flex justify-content-between align-items-center">
                                <h5 className="mb-0">{id ? "Редактирование пользователя" : "Добавление пользователя"}</h5>
                            </div>
                            <div className="card-body">
                                <Form
                                    state={{
                                        loading: false,
                                        error: "",
                                    }}

                                    submit={submit}

                                    fields={id ? updateFields : [
                                        {
                                            name: "name",
                                            title: "Имя",
                                            placeholder: "Укажите имя",
                                            value: form.name,
                                            type: FiledType.Text,
                                        },
                                        {
                                            name: "login",
                                            title: "Логин",
                                            placeholder: "Укажите логин",
                                            value: form.login,
                                            type: FiledType.Text,
                                        },
                                        {
                                            name: "pass",
                                            title: "Пароль",
                                            placeholder: "Укажите пароль",
                                            value: form.pass,
                                            type: FiledType.Text,
                                        },
                                    ]}
                                    btnSmall={true}
                                    submitBtnTitle={"Сохранить"}
                                    updateForm={updateForm}
                                />
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
